import React, { useCallback } from "react";
import AgGrid from "../AgGrid";

import SettingService from "../../../services/Setting";

import useItemCurrentStockColumnDef from "../../../hooks/Inventory/useItemCurrentStockColumnDef";

const ItemCurrentStockTable = ({
  gridRef,
  onGridReady,
  rowData,
  allLocation,
  isReport,
}) => {
  const getAllItemGroupLevel1 = useCallback(async () => {
    const data = await SettingService.getAllCategory();
    return data;
  }, []);

  const columnDefs = useItemCurrentStockColumnDef(
    isReport,
    allLocation,
    getAllItemGroupLevel1
  );

  return (
    <AgGrid
      ref={gridRef}
      columnDefs={columnDefs}
      height={680}
      onGridReady={onGridReady}
      rowData={rowData}
    />
  );
};

export default ItemCurrentStockTable;
